<template>
	<div class="ce-seperator-line">
		<hr>
	</div>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},

		data() {
			return {};
		},
		created() {
			// this.init();
		},
		methods: {},
		composed: {
			getfullheadline() {
				return;
			}
		}
	};
</script>

<style lang="scss">
	@import "@/scss/variables.scss";
	@import "@/scss/mixins.scss";
	hr {
		background: $color-white;
		border: none;
		height: 2px;
		margin: 50px auto;
		width: 60%;
		@include min-screen($screen-min-m) {
			margin: 60px auto;
			width: 40%;
			max-width: 430px;
		}
	}
</style>